<template>
    <div id="custom">
        <transition name="fade">
            <div id="loading-video" v-if="loading">
                <img src="@/assets/svg/logo.svg" alt="Chargement logo">
                <Loader/>
            </div>
        </transition>
        <transition name="fade">
        <div id="custom-zone" v-show="!loading">
            <div style="position:relative;width: 100%;">
                <video id="video-custom-intro"
                       src="https://player.vimeo.com/external/290865521.hd.mp4?s=33401e4c0e1ea3699de12c10c3bbb0210a8a1e20&profile_id=174"
                       autoplay
                ></video>
                <transition name="fade">
                    <ChooseYourPath v-show="time >= 14"/>
                </transition>
                <FullScreenButton/>
                <button id="skip" @click.once="skipIntro">Passer</button>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
    import ChooseYourPath from "../components/ChooseYourPath";
    import screenfull from 'screenfull'
    import FullScreenButton from "@/components/FullScreenButton";
    import Loader from "@/components/Loader";

    export default {
        name: "CustomPath",
        components: {ChooseYourPath, FullScreenButton,Loader},
        data() {
            return {
                time: 0,
                loading : true
            }
        },
        mounted() {
            this.loading = true
            this.video = document.querySelector("#video-custom-intro")
            this.video.oncanplay = () => {
                this.loading = false
            }
            this.video.ontimeupdate = () => {
                this.time = Math.floor(this.video.currentTime * 4) / 4;
                if (this.time >= 14) {
                    this.video.pause()
                    $("#skip").hide()
                }
            }
        },
        methods: {
            fs() {
                if (screenfull.enabled) {
                    screenfull.toggle();
                }
            },
            skipIntro(){
                this.video.currentTime = 13.75;
                $("#skip").hide()
            }
        }
    }
</script>

<style lang="scss" scoped>



    #custom {
        #loading-video {
            position: fixed;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            background-color: #3e6cc6;
            background: linear-gradient(45deg, #3e6cc6, #2237a2);
            background-size: cover;
            background-repeat: no-repeat;
            img {
                width: 220px;
                height: auto;
                margin-bottom: 100px;
            }
        }
        #custom-zone {
            background-color: black;
            position: fixed;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            #video-custom-intro {
                width: 100%;
                pointer-events: none
            }
            #skip {
                    border: 1px solid #fff;
                    background-color: transparent;
                    color: #fff;
                    padding: 20px 40px;
                    border-radius: 50px;
                    font-size: 1rem;
                    position: fixed;
                    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
                    cursor: pointer;
                    outline: none;
                    overflow: hidden;
                    bottom: 5%;
                    right: 5%;
                    &:hover {
                        background-color: #2235a1;
                        border: 1px solid #2235a1;
                        color: #fff;
                    }
                }
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }


</style>